import React, { useEffect, useState, useMemo } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
// complianceStandards removed — source is audited_departments
import { Redirect } from "react-router-dom";
import { LuPlus, LuGrid2X2, LuList } from "react-icons/lu";

import TopBar from "../../components/TopBar";
import Sidebar from "../../components/Sidebar";
import ComplianceCard from "../../components/Compliance/ComplianceCard"; // Card component for standards
import { getAuditDepartments } from "../../store/actions/surveyActions";
import { useTranslation } from "react-i18next";


function ComplianceCards(props) {
    const { t } = useTranslation();
    const { token, getAuditDepartmentsFN, departments } = props;

    useEffect(() => {
        getAuditDepartmentsFN();
    }, []);

    const [statusFilter, setStatusFilter] = useState("all");
    const [viewMode, setViewMode] = useState("grid");
    const [query, setQuery] = useState("");

    const complianceDepts = departments || [];

    console.log("complianceDepts:", complianceDepts);

    function getDisplayStatus(e) {
        if (e.status) return e.status;
        const score = e.audit_score != null ? Number(e.audit_score) : null;
        if (score == null) return "Partial";
        if (score >= 80) return "Compliant";
        if (score >= 50) return "Partial";
        return "Non-Compliant";
    }

    const filteredEntities = complianceDepts.filter((e) => {
        const text = `${e.name || ""} ${e.company_name || ""} ${e.entity_type || ""}`.toLowerCase();
        const matchesQuery = !query.trim() || text.includes(query.toLowerCase());
        const matchesStatus = statusFilter === "all" || getDisplayStatus(e) === statusFilter;
        return matchesQuery && matchesStatus;
    });

    const summary = React.useMemo(() => {
        const list = complianceDepts;

        let sum = 0;
        let countWithScore = 0;

        let compliantCount = 0;
        let partialCount = 0;
        let nonCompliantCount = 0;

        for (const e of list) {
            // status counts
            const s = e?.status;
            if (s === "Compliant") compliantCount++;
            else if (s === "Non-Compliant") nonCompliantCount++;
            else partialCount++; // default bucket

            // normalize score:
            // if audit_score is 0..1 => convert to %
            // if audit_score is already 0..100 => keep
            const raw = e?.audit_score;
            if (raw !== null && raw !== undefined && raw !== "") {
                const n = Number(raw);
                if (!Number.isNaN(n)) {
                    const pct = n <= 1 ? n * 100 : n;
                    sum += pct;
                    countWithScore++;
                }
            }
        }

        const overallCompliance =
            countWithScore > 0 ? Math.round(sum / countWithScore) : 0;

        return {
            overallCompliance,
            compliantCount,
            partialCount,
            nonCompliantCount,
        };
    }, [complianceDepts]);

    const trendPercent = 0;

    return token ? (



        <div className="flex flex-row w-full h-full overflow-hidden">
            {/* Sidebar */}


            {/* Main scrollable area */}
            <div className="flex flex-col w-full h-full overflow-hidden">
                <div className="w-full bg-[#F8F8F8] min-h-[100dvh] overflow-y-auto pb-28 pt-[20px]">
                    {/* Fixed-width page container */}
                    <div className="px-6">
                        <div className="w-full">
                            {/* Header */}
                            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 md:gap-4 mb-6">
                                <div>
                                    <h1 className="text-xl md:text-2xl font-medium tracking-wide text-[#0E0E0E]">
                                        {t("complianceOverview.pageTitle")}
                                    </h1>
                                    <p className="text-xs md:text-sm text-gray-500 mt-1">
                                        {t("complianceOverview.pageSubtitle")}
                                    </p>
                                </div>
                            </div>


                            {/* Top summary cards */}
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">

                                {/* Overall Compliance */}
                                <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-4">
                                    <p className="text-xs text-gray-500">{t("complianceOverview.overallCompliance")}</p>
                                    <p className="mt-2 text-4xl font-semibold text-[#0E0E0E]">
                                        {summary.overallCompliance}%
                                    </p>
                                    <p className="mt-1 text-xs text-gray-500">
                                        {t("complianceOverview.averageAcrossEntities")}
                                    </p>
                                </div>

                                {/* Status Overview */}
                                <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-4">
                                    <p className="text-xs text-gray-500 mb-3">{t("complianceOverview.statusOverview")}</p>

                                    <div className="space-y-1 text-sm">
                                        <div className="flex items-center justify-between">
                                            <span className="text-gray-700">{t("complianceOverview.compliant")}</span>
                                            <span className="text-green-600 font-medium">
                                                {summary.compliantCount}
                                            </span>
                                        </div>

                                        <div className="flex items-center justify-between">
                                            <span className="text-gray-700">{t("complianceOverview.partial")}</span>
                                            <span className="text-amber-500 font-medium">
                                                {summary.partialCount}
                                            </span>
                                        </div>

                                        <div className="flex items-center justify-between">
                                            <span className="text-gray-700">{t("complianceOverview.nonCompliant")}</span>
                                            <span className="text-rose-500 font-medium">
                                                {summary.nonCompliantCount}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                {/* Compliance Trend */}
                                <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-4">
                                    <p className="text-xs text-gray-500 mb-2">{t("complianceOverview.complianceTrend")}</p>

                                    <div className="h-24 rounded-xl bg-[#EEF2FF] relative overflow-hidden flex items-end px-3 pb-3">
                                        <div className="absolute inset-x-3 bottom-4 h-[2px] bg-blue-300" />
                                        <div className="w-full flex items-end justify-between relative">
                                            <div className="w-1.5 h-4 rounded-full bg-blue-300" />
                                            <div className="w-1.5 h-6 rounded-full bg-blue-400" />
                                            <div className="w-1.5 h-9 rounded-full bg-blue-500" />
                                            <div className="w-1.5 h-12 rounded-full bg-blue-600" />
                                        </div>
                                    </div>

                                    <p className="mt-2 text-xs text-gray-500">
                                        {t("complianceOverview.recentChange")}
                                        <span className="text-emerald-600 font-medium ml-1">
                                            {trendPercent > 0 ? `+${trendPercent}%` : `${trendPercent}%`}
                                        </span>
                                    </p>
                                </div>

                            </div>


                            {/* Search + filters */}
                            <div className="bg-white border border-gray-200 rounded-xl px-4 py-3 mb-5 shadow-sm">
                                <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
                                    {/* Search */}
                                    <div className="w-full md:flex-1">

                                        <div className="flex items-center gap-2">
                                            {/* Search */}
                                            <div className="relative flex-1">
                                                <input
                                                    className="w-full bg-[#F3F4F6] rounded-md text-sm pl-8 pr-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-300 focus:border-gray-400"
                                                    placeholder={t("complianceOverview.searchPlaceholder")}
                                                    value={query}
                                                    onChange={(e) => setQuery(e.target.value)}
                                                />
                                                <svg
                                                    className="absolute left-2.5 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                >
                                                    <circle cx="11" cy="11" r="6" stroke="currentColor" strokeWidth="1.5" />
                                                    <path d="m15 15 4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                                                </svg>
                                            </div>

                                            {/* Fake Entity Type filter */}
                                            <select
                                                className="h-9 rounded-md border border-gray-300 bg-white text-xs px-2"
                                                disabled
                                            >
                                                <option>{t("complianceOverview.allTypes")}</option>
                                                <option>{t("generalDashboard.department")}</option>
                                                <option>{t("generalDashboard.compliance")}</option>
                                            </select>

                                            {/* Fake Company filter */}
                                            <select
                                                className="h-9 rounded-md border border-gray-300 bg-white text-xs px-2"
                                                disabled
                                            >
                                                <option>{t("complianceOverview.allCompanies")}</option>
                                                <option>Company A</option>
                                                <option>Company B</option>
                                            </select>
                                        </div>

                                    </div>


                                    <div className="flex flex-wrap items-center gap-2 justify-end">


                                        {/* Status filter */}
                                        <select
                                            className="h-9 rounded-md border border-gray-300 bg-white text-xs px-2"
                                            value={statusFilter}
                                            onChange={(e) => setStatusFilter(e.target.value)}
                                        >
                                            <option value="all">{t("complianceOverview.allStatuses")}</option>
                                            <option value="Compliant">{t("complianceOverview.compliant")}</option>
                                            <option value="Partial">{t("complianceOverview.partial")}</option>
                                            <option value="Non-Compliant">{t("complianceOverview.nonCompliant")}</option>
                                        </select>

                                        {/* View toggle */}
                                        <div className="flex items-center gap-1 ml-1">
                                            {/* Grid view */}
                                            <button
                                                type="button"
                                                onClick={() => setViewMode("grid")}
                                                className={`
                h-9 w-9 rounded-md border text-xs flex items-center justify-center transition
                ${viewMode === "grid"
                                                        ? "bg-[#0F0F19] text-white border-transparent"
                                                        : "bg-white text-gray-600 border-gray-300 hover:bg-gray-100"
                                                    }
            `}
                                                aria-label="Grid view"
                                            >
                                                <LuGrid2X2 className="w-4 h-4" />
                                            </button>

                                            {/* List / table view */}
                                            <button
                                                type="button"
                                                onClick={() => setViewMode("list")}
                                                className={`
                h-9 w-9 rounded-md border text-xs flex items-center justify-center transition
                ${viewMode === "list"
                                                        ? "bg-[#0F0F19] text-white border-transparent"
                                                        : "bg-white text-gray-600 border-gray-300 hover:bg-gray-100"
                                                    }
            `}
                                                aria-label="List view"
                                            >
                                                <LuList className="w-4 h-4" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Standards grid / list */}
                            {viewMode === "grid" ? (
                                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                                    {filteredEntities?.map((standard) => (
                                        <ComplianceCard
                                            key={standard.id || standard.compliance_id || standard.name}
                                            standard={standard}
                                            viewMode="grid"
                                        />
                                    ))}
                                </div>
                            ) : (
                                <div className="flex flex-col gap-4">
                                    {filteredEntities?.map((standard) => (
                                        <ComplianceCard
                                            key={standard.id || standard.compliance_id || standard.name}
                                            standard={standard}
                                            viewMode="list"
                                        />
                                    ))}
                                </div>
                            )}

                        </div>
                    </div>
                </div>
            </div>
        </div>

    ) : (
        <Redirect to="/login" />
    );

}
const getScoreStyle = (score) => {
    const n = Number(score);
    if (!Number.isFinite(n)) {
        return { wrap: "bg-gray-50 border-gray-200", text: "text-gray-600", label: "ÔÇö" };
    }
    if (n >= 85) return { wrap: "bg-emerald-50 border-emerald-200", text: "text-emerald-700", label: n };
    if (n >= 70) return { wrap: "bg-blue-50 border-blue-200", text: "text-blue-700", label: n };
    if (n >= 55) return { wrap: "bg-amber-50 border-amber-200", text: "text-amber-700", label: n };
    return { wrap: "bg-rose-50 border-rose-200", text: "text-rose-700", label: n };
};


const AuditedEntityCard = ({ entity }) => {
    const isCompliance = entity.entity_type === "compliance";

    return (
        <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-4 hover:shadow-md transition">
            {/* top row: name + type pill */}
            <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                    <div className="flex items-center gap-2 min-w-0">
                        <h3 className="text-sm font-semibold text-gray-900 truncate" title={entity.name || ""}>
                            {entity.name || "Untitled"}
                        </h3>

                        {/* small indicator */}
                        <span
                            className={`text-[10px] px-2 py-0.5 rounded-full border whitespace-nowrap
                ${isCompliance
                                    ? "bg-indigo-50 text-indigo-700 border-indigo-200"
                                    : "bg-emerald-50 text-emerald-700 border-emerald-200"
                                }`}
                        >
                            {isCompliance ? "Compliance" : "Department"}
                        </span>
                    </div>

                    {/* company name WHERE category used to be */}
                    <p className="text-xs text-gray-500 mt-1 truncate" title={entity.company_name || ""}>
                        {entity.company_name || "ÔÇö"}
                    </p>
                </div>

                {/* score */}
                {(() => {
                    const s = getScoreStyle(entity.audit_score);
                    return (
                        <div className="text-right">
                            <p className="text-[11px] text-gray-500">Score</p>
                            <div className={`mt-1 inline-flex items-center justify-center px-2.5 py-1 rounded-full border ${s.wrap}`}>
                                <span className={`text-sm font-semibold ${s.text}`}>{s.label}</span>
                            </div>
                        </div>
                    );
                })()}
            </div>

            <div className="mt-3 text-xs text-gray-500">
                Audit #{entity.audit_id ?? "ÔÇö"}
            </div>
        </div>
    );
};


const mapStateToProps = (state) => {
    console.log("Audioted stuff ", state.audits.audited_departments)
    return {
        token: state.auth.token,
        departments: state.audits.audited_departments,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAuditDepartmentsFN: () => dispatch(getAuditDepartments()),
    };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(ComplianceCards);